<template>
    <h3>HostUploadAgent.vue</h3>
    <hr />

    <div class="container-main-div">

        <div style="text-align: right; margin-right: 10px; font-size: 22px; color: darkblue;">
            Use to Upload files:
        </div>

        <div>
            <UploadAgent @proccessFiles="handle_proccessFiles" 
                         :ServerUploadFiles="serverUploadFiles"
                         :EnableMultiFileSelection = enableMultiFileSelection>
            </UploadAgent>
        </div>

        <div>
            <span  style="margin-right: 20px; font-weight: bolder;">Multi-file Selection Enabled:</span>
            <input type="checkbox" v-model="enableMultiFileSelection"/>
        </div>

    </div>

</template>
  
<script>
import axios from "axios";
import UploadAgent from "../../../components/dataSupport/UploadAgent.vue";

export default {
    data() {
        return {

            enableFunctionTracing: false,
            enableDataLogging: false,

            enableMultiFileSelection: false,

            //This will hold the results object from the server.
            serverUploadFiles: null,
        };
    },
    props: {},
    watch: {},
    created() { },
    mounted() {
    },
    components: { UploadAgent },
    computed: {},
    methods: {

        handle_proccessFiles(filesToUpload) {
            if (this.$data.enableFunctionTracing) {
                console.log("**** HostUploadAgen.vue: handle_proccessFiles() ****");
            }
            if (this.$data.enableDataLogging) {
                console.log('--- handle_proccessFiles() ---');
                this.log_fileFormData(filesToUpload);
            }
            this.sendFilesToServer(filesToUpload);

        },

        sendFilesToServer(filesToUpload) {
            if (this.$data.enableFunctionTracing) {
                console.log("**** sendFilesToServer ****");
            }
            axios.defaults.headers.post["Content-Type"] = "multipart/form-data";

            return axios.post("https://localhost:7100/api/File/uploadFileObject", filesToUpload
            ).then((response) => {
                return response.data;
            }).then((data) => {

                this.$data.serverUploadFiles = {
                    ErrorFound: data.errorFound,
                    UploadResults: data.uploadResults,
                    FileList: new Array(),
                }
                data.fileList.forEach((element) => {
                    this.$data.serverUploadFiles.FileList.push(element);
                });

                if (this.$data.enableDataLogging) {
                    this.log_fileJasonData(this.$data.serverUploadFiles);
                }
            });
        },

        log_fileFormData(filesToUpload) {
            console.log('####################  99 Start ####################');
            console.log('############## Input File Form Data ###############');
            console.log('filesToUpload = ', filesToUpload);
            filesToUpload.forEach((element) => {
                console.log('-----------');
                console.log('element.size = ', element.size);
                console.log('element.name = ', element.name);
            });
            console.log('############## 99 End ###############');
        },

        log_fileJasonData(returnFileJasonObject) {
            console.log('####################  88 Start ######################');
            console.log('############## Output Jason File Data ###############');
            console.log('returnFileJasonObject.ErrorFound = ', returnFileJasonObject.ErrorFound);
            console.log('returnFileJasonObject.UploadResults = ', returnFileJasonObject.UploadResults);
            console.log('returnFileJasonObject.FileList:');
            for (let i = 0; i < this.$data.serverUploadFiles.FileList.length; i++) {
                console.log('fileName = ', returnFileJasonObject.FileList[i]);
            }
            console.log('############## 88 End ###############');
        },

    },
};
</script>
  
<style scoped>
.container-main-div {
    display: grid;
    grid-template-rows: auto;
    grid-template-columns: 33% auto 33%;
}

.columnDivs {
    display: flex;
    flex-direction: column;
}

.childDiv {
    border: 1px black solid;
    padding: 40px;
}
</style>
  